import httpApiApplication, { type HttpApiApplication } from 'app/http/httpApiApplication';
import httpApiSecurity, { type HttpApiSecurity } from 'app/http/httpApiSecurity';

import { type EnvironmentVariable } from './types';

export const baseUrlEnvironmentVariables = '/environment';

const services: Record<string, HttpApiApplication | HttpApiSecurity> = {
  security: httpApiSecurity,
  application: httpApiApplication
};

class EnviromentVariablesService {
  getExternalWsLoginEnabled(): Promise<EnvironmentVariable> | Promise<any> {
    return services['security']
      .get<EnvironmentVariable>(`v1/environment/getexternalwsloginenabled`)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }
}

export default new EnviromentVariablesService();
